import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseModal from './BaseModal';

/**
 * Video Modal Component
 * Displays YouTube video in a responsive modal
 */
const VideoModal = ({ isOpen, onClose, videoUrl }) => {
  const { t } = useTranslation();

  // Extract YouTube video ID from URL
  const getYouTubeEmbedUrl = (url) => {
    if (!url) return '';
    
    // Handle various YouTube URL formats
    let videoId = '';
    if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1].split('?')[0];
    } else if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('v=')[1].split('&')[0];
    } else if (url.includes('youtube.com/embed/')) {
      videoId = url.split('embed/')[1].split('?')[0];
    }
    
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
  };

  const embedUrl = getYouTubeEmbedUrl(videoUrl);

  return (
    <BaseModal 
      isOpen={isOpen} 
      onClose={onClose}
      maxWidth="max-w-5xl"
    >
      <div className="pt-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4 sm:mb-6 pr-8">
          {t('videoModal.title')}
        </h2>
        
        {/* Video Container - Responsive 16:9 aspect ratio */}
        <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
          <iframe
            className="absolute top-0 left-0 w-full h-full rounded-2xl"
            src={embedUrl}
            title="Smart Home Demo Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        <p className="text-white/70 text-sm sm:text-base mt-4 sm:mt-6">
          {t('videoModal.description')}
        </p>
      </div>
    </BaseModal>
  );
};

export default VideoModal;
